import * as FileActionTypes from '../actions/constants';

const initialState = {
  busy: false,
  filePreview: {},
};

const fileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FileActionTypes.FILE_UPLOADING: {
      const newFilePreview = {};
      newFilePreview[action.payload] = { busy: true };
      const filePreview = Object.assign(state.filePreview, newFilePreview);
      return Object.assign({}, state, { filePreview });
    }
    case FileActionTypes.FILE_TEMP_UPLOADED: {
      const filePreview = Object.assign(state.filePreview, action.payload);
      return Object.assign({}, state, { filePreview });
    }
    case FileActionTypes.FILE_UPLOADED: {
      const filePreview = Object.assign(state.filePreview, action.payload);
      return Object.assign({}, state, { filePreview });
    }
    case FileActionTypes.FILE_CROPPED: {
      const filePreview = Object.assign(state.filePreview, action.payload);
      return Object.assign({}, state, { filePreview });
    }
    case FileActionTypes.UPLOAD_INTERRUPTED: {
      return Object.assign({},
        state,
        {
          busy: false,
          filePreview: {
            busy: false,
          }
        }
      );
    }
    default:
      return state;
  }
};

export default fileReducer;



/** WEBPACK FOOTER **
 ** ./src/cards/reducers/file.js
 **/